import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import router from '../router/router'

if ('production' === process.env.BO_ENV) {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.BO_ENV,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.2,
  })
}
